import {
  Progress as AntdProgress,
  ProgressProps as AntdProgressProps,
} from "antd";
import { CMP_PREFIX } from "@/base/constant";

export interface ProgressProps extends AntdProgressProps {}

export const progressPrefixCls = `${CMP_PREFIX}-progress`;

export const Progress = ({ ...props }: ProgressProps) => {
  return <AntdProgress {...props} />;
};
